import { Routes } from '@angular/router'

import { stepModeRoutes } from '@yoshu-lib/features/interaction-modes/step-mode/step-mode.routes'

import { authGuard } from '@coty/core/auth/auth.guard'
import { redirectIfAuthGuard } from '@coty/core/auth/redirect-if-auth.guard'

import { interactionRoutes } from '@coty/pages/interactions/interactions.routes'

import { environment } from '@coty/env/environment'

import { adminGuard } from './core/auth/admin.guard'

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layouts/main/main-layout.component').then((m) => m.MainLayoutComponent),
    children: [
      {
        path: '',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/interactions/failure-mode/start-failure-mode.component').then(
            (m) => m.StartFailureModeComponent
          )
      },

      {
        path: 'protocols',
        canActivate: [authGuard],
        children: stepModeRoutes
      },

      ...(environment.features['module.free-mode']
        ? ([
            {
              path: 'free-chat',
              loadComponent: () =>
                import(
                  '@yoshu-lib/features/interaction-modes/free-mode/start-free-mode/start-free-mode.component'
                ).then((m) => m.StartFreeModeComponent)
            }
          ] as Routes)
        : []),

      {
        path: 'interactions',
        canActivate: [authGuard],
        children: interactionRoutes
      },

      {
        path: 'conversations',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/interactions-list/interactions-list.component').then(
            (m) => m.InteractionsListComponent
          )
      }
    ]
  },

  ...(environment.features['module.admin']
    ? [
        {
          path: 'admin',
          canActivate: [adminGuard],
          loadComponent: () =>
            import('./pages/admin/admin.component').then((m) => m.AdminComponent),
          children: [
            {
              path: '',
              loadChildren: () =>
                import('@yoshu-lib/features/admin/admin.routes').then((m) => m.routes)
            }
          ]
        } satisfies Routes[number]
      ]
    : []),

  {
    path: 'login',
    canActivate: [redirectIfAuthGuard],
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent)
  },

  {
    path: '**',
    redirectTo: ''
  }
]
